import React from "react";
import "./AboutUs.css";
import { Link } from "react-router-dom";

// Optional: Import a background pattern or icons
// import { FaHeart, FaLeaf, FaClock } from "react-icons/fa";

export default function AboutUs() {
  return (
    <section className="about-section">
      <div className="about-container">
        {/* Left Column: Image / Visual */}
        <div className="about-image" data-aos="fade-right">
          <img
            src="https://images.unsplash.com/photo-1509440159596-0249088772ff?w=800&h=800&fit=crop"
            alt="Freshly baked bread and pastries"
          />
          <div className="about-image-overlay">
            <span>Since 1996</span>
          </div>
        </div>

        <div className="about-content" data-aos="fade-left">
          <span className="about-tag">ABOUT US</span>

          <h2>
            A Legacy of Baking <span>Since 1996</span>
            {/* <br />
            Into Every Bite */}
          </h2>

          <p className="about-description">
            Founded in 1996 in Aurangabad, Maharashtra, Royal Bakers & Confectioners has been serving customers with quality bakery and confectionery products for nearly three decades.
          </p>
          <p className="about-description">
            Over the years, the company has grown from a local bakery into an expanding business with a wider vision for the future. Our journey has been shaped by years of experience in baking, an understanding of customer preferences, and the trust we have received from the people who have been with us along the way.
          </p>
          <div className="d-flex justify-content-center">

            <Link to={'/about'} className="about-btn">
              Discover Our Story
            </Link>
          </div>

          <div className="about-stats mt-4">

            <div className="stat">
              <h3>30+</h3>
              <span>Years</span>
            </div>

            <div className="stat">
              <h3>60+</h3>
              <span>Products</span>
            </div>

            <div className="stat">
              <h3>10K+</h3>
              <span>Customers</span>
            </div>

          </div>


        </div>
      </div>
    </section>
  );
}